import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import AddOrEditOptionGroup from '../OptionGroups/AddOrEditOptionGroup';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';


export default function FoodAndDrinks2_AddOrEditProduct_View(props) {
    const classes = useStyles();
    const [currency, setCurrency] = useState('');
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const [translateGui] = useGuiTranslations();

    useEffect (
        () => {
            if(getCustomerSettingsHookResponse.currency != null) {
                setCurrency(getCustomerSettingsHookResponse.currency.toUpperCase());
            }
            //console.log(getCustomerSettingsHookResponse);
        },[getCustomerSettingsHookResponse]
    )

    const PictureUpload = (rowInfo) => {
        return (
            <div value="photo">
                <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={(e) => { props.setSelectedFileToImageSrc(e.target.files[0]); props.setFileInfo(e.target.files[0]) }}
                />

                <span>{capitalizeFirstLetter(translateGui(41))}:</span>
                <label htmlFor="raised-button-file">
                    <Button className={classes.addImageButton} color="primary" variant="outlined" component="span">
                    {capitalizeFirstLetter(translateGui(42))}
                    </Button>
                </label>
                <Button className={classes.addImageButton} color="primary" component="span"
                    onClick={(e) => { props.setSelectedFileToImageSrc(null) ; props.setFileInfo(null); props.setPictureUrl(null); }}
                >
                    {capitalizeFirstLetter(translateGui(43))}
                </Button>

            </div>

        )
    }

    return (
        <div className={classes.root}>
            <div className={classes.formElementsWrapper}>
                <TextField id="name" label={capitalizeFirstLetter(translateGui(36))} value={props.name} onChange={(e) => props.setName(e.target.value)} helperText={props.nameError} error={props.nameError == '' ? false : true} />
                <TextField multiline rows="4" id="description" label={capitalizeFirstLetter(translateGui(37))} value={props.description} onChange={(e) => props.setDesription(e.target.value)} />
                <TextField type="number" id="price" label={capitalizeFirstLetter(translateGui(27))} value={props.price} onChange={(e) => props.setPrice(e.target.value)}
                    InputProps={{
                    startAdornment: <InputAdornment position="start">{currency}</InputAdornment>,
                    }} />

                <div>
                    <label>{capitalizeFirstLetter(translateGui(33))}</label>
                    <Checkbox
                        checked={props.available}
                        value="secondary"
                        color="primary"
                        onChange={(e) => props.setAvailable(e.target.checked)}
                    />
                </div>
                <TextField id="productGroups" label={capitalizeFirstLetter(translateGui(39))} value={props.productGroup} onChange={(e) => props.setProductGroup(e.target.value)} />
                <div className={classes.optionGroupsWrapper}>
                    <div className={classes.optionGroupTitle}>{capitalizeFirstLetter(translateGui(7))}:</div>
                    <div>
                        <Select
                            className={classes.combobox}
                            value={props.optionGroupSelectValue}
                            onChange={(e) => props.setOptionGroupSelectValue(e.target.value)}
                        >
                            {
                                props.getOptionGroupsHookResponse.foodOptionGroups != null ?
                                    props.getOptionGroupsHookResponse.foodOptionGroups.map(
                                        optionGroup =>
                                            <MenuItem key={optionGroup.id} value={optionGroup.id}>{optionGroup.optionGroupName}</MenuItem>
                                    )
                                    : null
                            }

                        </Select>
                        <Button aria-label="add option group button" onClick={props.addToOptionGroups} className={classes.addOptionGroupButton} color="primary" variant="outlined" component="button">
                            {capitalizeFirstLetter(translateGui(40))}
                    </Button>
                    </div>
                    <div className={classes.addedOptionGroupsWrapper}>
                        {
                            props.optionGroups.map(
                                (optionGroup, index) =>
                                    <div key={index} className={classes.addedOptionGroupRow}>
                                        <div>
                                            {optionGroup.name}
                                        </div>
                                        <div>
                                            <EditIcon className={classes.cursor} style={{ marginLeft: '15px' }} onClick={() => props.setOptionGroupId(optionGroup.id)}></EditIcon>
                                            <DeleteIcon className={classes.cursor} onClick={() => props.removeFromOptionGroups(optionGroup.id)}></DeleteIcon>
                                        </div>
                                    </div>
                            )
                        }
                    </div>
                    <Button style={{display:'none'}} color="primary" variant="text" component="button" onClick={() => props.setOptionGroupId(0)}>
                        Add new option group
                </Button>
                </div>

                <PictureUpload></PictureUpload>
                <img className={classes.foodImage} src={props.pictureUrl}></img>

                <div className={classes.okAndCancelButtonWrapper}>
                    <Button color="primary" variant="text" component="button" onClick={props.closeForm}>
                    {capitalizeFirstLetter(translateGui(44))}
                    </Button>
                    <Button aria-label="save product button" className={classes.okButton} color="primary" variant="contained" component="button" onClick={props.submit}>
                    {capitalizeFirstLetter(translateGui(45))}
                    </Button>
                </div>
            </div>
            {
                props.optionGroupId > -1 ?
                    <AddOrEditOptionGroup
                        optionGroupId={props.optionGroupId}
                        setSelectedOptionGroupIdAndCloseOptionGroupForm={props.setSelectedOptionGroupIdAndCloseOptionGroupForm}
                        closeForm={() => props.setOptionGroupId(-1)} />
                    : null
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        maxWidth: '600px',
    },
    formElementsWrapper: {
        display: 'flex',
        flexDirection: 'column',

        "& > div": {
            marginTop: '15px',
        }
    },
    foodImage: { "width": "300px", "margin": "20px 0" },
    addImageButton: { "marginLeft": "20px" },
    okAndCancelButtonWrapper: { "bottom": "0", "backgroundColor": "#f7f7f7", "display": "flex", "justifyContent": "flex-end", "width": "100%", "left": "0" },
    okButton: { "margin": "10px 10px" },
    optionGroupsWrapper: { "borderBottom": "1px solid gray", "borderTop": "1px solid gray", "backgroundColor": "white", padding: '10px' },
    combobox: { width: '250px', },
    addOptionGroupButton: { width: '250px', margin: '10px 0' },
    optionGroupTitle: { fontSize: '1.2rem', fontWeight: '500', },
    addedOptionGroupsWrapper: { padding: '10px 0', },
    addedOptionGroupRow: { "width": "250px", "display": "flex", "alignItems": "center", "justifyContent": "space-between" },
    cursor: {cursor:'pointer'},
    '@media (min-width:600px)': {
        addOptionGroupButton: { marginLeft: '10px' },
    }
});